import { useController } from "./Controller";
import { Loading, ComingSoon, Modal } from "components/commons";
import { useEffect, useMemo, useState } from "react";
import { BellIcon, BellSnoozeIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { BigNumber, ethers } from "ethers";
import { formatAmount, formatNumber } from "utils/number/number";
import { Breadcum } from "components/commons/Breadcum";
import { appConfig } from "services/blockchain";
import { Dialog } from "@headlessui/react";
import abi from "abis/Fantech.json";
import slugs from "navigation/slugs";
import { tabs } from "helpers/constants";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

const fantechCA = appConfig.fantechAddress;
const defaultAmount = 1;

const provider = appConfig.provider;
const fanTechContract = new ethers.Contract(fantechCA, abi, provider);

function OtherProfile() {
  const [sellPrice, setSellPrice] = useState(BigNumber.from(0));
  const [isOpenComingSoon, setIsOpenComingSoon] = useState<boolean>(false);
  const navigate = useNavigate();

  // console.log("location", location.pathname);
  const {
    data,
    currentTab,
    setCurrentTab,
    isLoading,
    status,
    isSubscribed,
    handleSubscribe,
    totalHolding,
    handleUnsubscribe,
    accountShares,
    handleBuyShare,
    handleSellShare,
    buyPrice,
    poolSupply,
  } = useController();
  const [isOpenTrade, setIsOpenTrade] = useState<boolean>(false);
  const [isOpenInvite, setIsOpenInvite] = useState<boolean>(false);

  const toggleModalTrade = () => {
    setIsOpenTrade(!isOpenTrade);
  };

  const toggleModalInvite = () => {
    setIsOpenInvite(!isOpenInvite);
  };

  const tabRender = () => {
    switch (currentTab) {
      case "Stream":
        return (
          <ComingSoon
            type="speaker"
            title={accountShares && accountShares > 0 ? "Coming soon!" : ""}
            des={
              accountShares && accountShares > 0
                ? `Exclusive videos for ${data?.nickname}’s Shareholders only.`
                : `Hold the least 1 ${data?.nickname}’s Share to access exclusive contents.`
            }
          />
        );

      case "Perks":
        return (
          <ComingSoon
            type="gift"
            des={`Exclusive Perks for ${data?.nickname}’s Shareholders only.`}
          />
        );

      default:
        break;
    }
  };

  const toggleModalComingSoon = () => {
    setIsOpenComingSoon(!isOpenComingSoon);
  };

  const subjectAddress = data?.sub_address;

  useEffect(() => {
    const f = async () => {
      if (!subjectAddress) return;
      try {
        const price = await fanTechContract.getSellPriceAfterFee(
          subjectAddress,
          defaultAmount
        );
        setSellPrice(price);
      } catch (error) {
        console.log("🚀 ~ file: OtherProfile.tsx:218 ~ f ~ error:", error);
      }
    };
    f();
  }, [subjectAddress]);

  if (!isLoading && status === "lock_not_on_fan_tech") {
    return (
      <>
        <Breadcum title={data?.nickname} />
        <div className="h-10 block"> </div>
        <div className="p-4 h-full flex-1 flex items-center justify-center">
          <div className="px-6 gap-4 flex flex-col justify-center items-center">
            <div className="flex flex-col justify-center items-center gap-3">
              <img
                className="border w-20 h-20 rounded-full border-slate-700"
                src={data?.metadata?.avatar_300x300}
                alt="avatar"
              />
              <div className="mx-auto space-y-2">
                <div className="text-center font-normal text-base">
                  This Idol is not on fan.tech yet
                </div>
                <div className="text-center text-[#F97316] text-sm">
                  🔔 Subscribe to be notified when their share is enable for
                  trading.
                </div>
              </div>

              <div className="flex flex-col justify-center items-center gap-1">
                <span className="text-xl">
                  {formatNumber(data?.follower_count ?? 0)}
                </span>{" "}
                <span className="text-xs text-slate-500">Follower</span>
              </div>

              <div className="w-12 h-12">
                <button
                  className="border-2 border-gray-800 rounded-xl px-[14px] py-3 uppercase"
                  onClick={(e) => {
                    e.preventDefault();
                    isSubscribed ? handleUnsubscribe() : handleSubscribe();
                  }}
                >
                  {isSubscribed ? (
                    <BellIcon className="w-5 h-5 text-[#1BC57E]" />
                  ) : (
                    <BellSnoozeIcon className="w-5 h-5" />
                  )}
                </button>
              </div>

              <div>
                <div className="text-center text-[#40F8FF] text-base">
                  {data?.numFan} fans are waiting!
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Breadcum title={data?.nickname} />

      {isLoading && <Loading />}
      <Modal isOpen={isOpenTrade} toggleModal={toggleModalTrade}>
        <div className=" border-gray-800 px-4">
          <div className="space-y-4">
            <div className="flex justify-center items-center gap-4">
              <img
                className="border w-16 h-16 rounded-full border-slate-700"
                src={data?.metadata?.avatar_168x168}
              />
              <div className="space-y-1 flex-1">
                <div>{data?.unique_id}</div>{" "}
                <div className="text-xs text-slate-500 font-normal">
                  You own {accountShares || 0} shares
                </div>
              </div>
              <div className="space-y-1">
                <div className="text-right">
                  {formatAmount(buyPrice, 18, 4)} ETH
                </div>{" "}
                <div className="text-right text-xs text-slate-500 font-normal">
                  Share price{" "}
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center px-4 gap-3 pb-8">
          <button
            className="rounded-xl btn bg-secondary uppercase w-full"
            onClick={async (e) => {
              e.preventDefault();
              handleBuyShare();
            }}
          >
            Buy a Share
          </button>

          <button
            className="rounded-xl btn bg-[#279EFF] uppercase w-full"
            onClick={(e) => {
              e.preventDefault();
              handleSellShare();
            }}
          >
            Sell a Share
          </button>
          <div className="text-xs text-slate-300 font-normal text-center pt-4">
            Sell price: {formatAmount(sellPrice ?? 0, 18, 4)} ETH
          </div>
        </div>
      </Modal>

      {!isLoading && (
        <>
          <div className="p-4 mt-10">
            <div className="px-6 gap-4 flex flex-col justify-center items-center">
              <div className="flex flex-col justify-center items-center gap-2">
                <a
                  target="blank"
                  href={`https://www.tiktok.com/@${data?.unique_id}`}
                >
                  <img
                    className="border w-20 h-20 rounded-full border-slate-700"
                    src={data?.metadata?.avatar_300x300}
                    alt="avatar"
                  />
                </a>
                <div className="text-xs text-center font-normal">
                  @{data?.unique_id}
                </div>
                <div className="mx-auto space-y-2">
                  <div className="flex items-center justify-center  gap-1 rounded-xl py-1.5 px-3">
                    <div className="w-6 h-6 rounded-full bg-[#279EFF] border-[3px] border-[#51B1FF] text-xs font-bold flex justify-center items-center">
                      S
                    </div>
                    {formatAmount(buyPrice, 18, 4)} ETH
                  </div>{" "}
                  <div className="text-xs text-center font-normal text-[#40F8FF]">
                    You own {accountShares || 0} Share
                  </div>
                </div>
                <div className="flex gap-6 px-12">
                  <div className="flex flex-col text-center gap-1">
                    <span>
                      {data?.follower_count
                        ? formatNumber(data?.follower_count)
                        : "-"}
                    </span>{" "}
                    <span className="text-xs text-slate-500">Follower</span>
                  </div>
                  <div className="flex flex-col text-center gap-1">
                    <span>{data?.total_shares || "-"}</span>{" "}
                    <span className="text-xs text-slate-500">Shares</span>
                  </div>
                  <div
                    className="flex flex-col text-center gap-1"
                    onClick={() => {
                      navigate(`/profile/activities/${data?.id}?tab=Holders`, {
                        state: {
                          nickname: data?.nickname,
                          avatar: data?.metadata?.avatar_168x168,
                          id: data?.user_id,
                          tiktok_user_id: data?.id,
                        },
                      });
                    }}
                  >
                    <span>{data?.total_holders || "-"}</span>{" "}
                    <span className="text-xs text-slate-500">Holders</span>
                  </div>
                  <div
                    className="flex flex-col text-center gap-1"
                    onClick={() => {
                      navigate(`/profile/activities/${data?.id}?tab=Holdings`, {
                        state: {
                          nickname: data?.nickname,
                          avatar: data?.metadata?.avatar_168x168,
                          id: data?.user_id,
                          tiktok_user_id: data?.id,
                        },
                      });
                    }}
                  >
                    <span>{totalHolding || "-"}</span>{" "}
                    <span className="text-xs text-slate-500">Holdings</span>
                  </div>
                </div>
              </div>

              {status === "unlock" && (
                <div className="flex gap-2 items-center justify-center mx-auto">
                  <button
                    className="rounded-xl btn bg-[#1BC57E] uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleModalTrade();
                    }}
                  >
                    Trade a Share
                  </button>
                  <button
                    className="border-2 border-gray-800 rounded-xl btn btn-outline uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`${slugs.profile}/activities/${data?.id}`, {
                        state: {
                          nickname: data?.nickname,
                          avatar: data?.metadata?.avatar_168x168,
                          id: data?.user_id,
                          tiktok_user_id: data?.id,
                        },
                      });
                    }}
                  >
                    Activities
                  </button>
                  <div className="w-12 h-12">
                    <button
                      className="border-2 border-gray-800 rounded-xl px-[14px] py-3 uppercase"
                      onClick={(e) => {
                        e.preventDefault();
                        isSubscribed ? handleUnsubscribe() : handleSubscribe();
                      }}
                    >
                      {isSubscribed ? (
                        <BellIcon className="w-5 h-5 text-[#1BC57E]" />
                      ) : (
                        <BellSnoozeIcon className="w-5 h-5" />
                      )}
                    </button>
                  </div>
                </div>
              )}

              {status === "lock" && (
                <div className="flex justify-center gap-2 items-center">
                  <button
                    className="rounded-xl btn bg-secondary uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      handleBuyShare();
                    }}
                    disabled={poolSupply === 0}
                  >
                    Buy a Share{" "}
                  </button>
                  <button
                    className="border-2 border-gray-800 rounded-xl btn btn-outline uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`${slugs.profile}/activities/${data?.id}`, {
                        state: {
                          nickname: data?.nickname,
                          avatar: data?.metadata?.avatar_168x168,
                          id: data?.user_id,
                          tiktok_user_id: data?.id,
                        },
                      });
                    }}
                  >
                    Activities
                  </button>
                  <div className="w-12 h-12">
                    <button
                      className="border-2 border-gray-800 rounded-xl px-[14px] py-3 uppercase"
                      onClick={(e) => {
                        e.preventDefault();
                        isSubscribed ? handleUnsubscribe() : handleSubscribe();
                      }}
                    >
                      {isSubscribed ? (
                        <BellIcon className="w-5 h-5 text-[#1BC57E]" />
                      ) : (
                        <BellSnoozeIcon className="w-5 h-5" />
                      )}
                    </button>
                  </div>
                </div>
              )}

              <span className="text-slate-300 text-sm text-center">
                {data?.signature ? data.signature : null}
              </span>
            </div>
          </div>
          <div className="px-4 flex justify-evenly items-center gap-6 border-b border-gray-800 text-center z-10">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                className={classNames(
                  tab.name === currentTab
                    ? "border-secondary text-white"
                    : "border-transparent text-slate-300 hover:border-secondary hover:text-white",
                  "whitespace-nowrap border-b-4 rounded text-sm font-normal pt-3 pb-2 w-full px-1 cursor-pointer"
                )}
                onClick={() => {
                  setCurrentTab(tab.name);
                }}
              >
                {tab.name}
              </div>
            ))}
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            {tabRender()}
          </div>
        </>
      )}
    </>
  );
}

export { OtherProfile as default };
